import { Image } from 'expo-image';
import { router } from 'expo-router';
import { StyleSheet, TouchableOpacity, TouchableOpacityProps } from 'react-native';

import { trb_banner } from '@/assets/images/trbShow';
import { BLUR_HASH } from '@/constants/layout';
import { useAuth } from '@/contexts/authContext';
import { useInfoModal } from '@/contexts/infoModalContext';

type TRBShowBannerProps = TouchableOpacityProps;

const TRBShowBanner = (props: TRBShowBannerProps) => {
  const { state } = useAuth();
  const { showInfo } = useInfoModal();

  const onPress = () => {
    if (state.authReady && !state.user?.user) {
      router.navigate({
        pathname: '/(app)/login/individual',
        params: {
          buyingShow: 'true'
        }
      });
    }
    if (state.authReady && state.user?.user && state.user.user.role === 'INDIVIDUAL') {
      router.navigate('/(app)/purchaseShow');
    }

    if (state.authReady && state.user?.user && state.user.user.role === 'NON_PROFIT_ORG') {
      showInfo({ type: 'title', title: 'Sorry', message: 'Only individuals can buy the show' });
    }
  };

  return (
    <TouchableOpacity {...props} onPress={onPress}>
      <Image contentFit="contain" source={trb_banner} style={styles.image} placeholder={BLUR_HASH} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  image: {
    width: '100%',
    height: 95
  }
});

export default TRBShowBanner;
